import React from 'react'
import { Container, Row, Col, Image, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router";
import DevopsApproachCarousel from './DevopsApproachCarousel';
import TechBlock from '../TechBlock';
import DevopsCloudFaq from './DevopsCloudFaq';
import ServiceSlider from './ServiceSlider';

import gradient from "../../Assets/banner-blue-pill.png";

export default function DevopsClouldSolutions() {
    return (
        <>
            <section className='bg-theme section-hero'>
                <Container className="header-section pb-5 pt-2">
                    <Breadcrumb className="custom-breadcrumb">
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item href="/service">
                            Services
                        </Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item active>DevOps & Cloud Solutions</Breadcrumb.Item>
                    </Breadcrumb>
                    <Row className='mb-4 pt-5'>
                        <Col md={11}>
                            <h2 className="heading-style-h2 pb-3 text-white"><span className="text-gradient-1">DevOps & Cloud </span> Solutions</h2>
                            <h5 className='heading-style-h5 pb-5 text-white'>Making it easier to manage infrastructure, streamline deployments, and keep systems running without constant friction.</h5>
                        </Col>
                    </Row>
                    <div className="pills-wrap">

                        <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                            <Image src={gradient} />
                        </div>
                    </div>
                </Container >
            </section >
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">Where <span className="text-gradient-1"> DevOps and Cloud</span><br /> Fit into Your Systems</h2>
                        </Col>
                        <h5 className='heading-style-h5 mb-5'>As systems grow, managing deployments, infrastructure, and performance starts getting harder to handle day to day. DevOps and cloud solutions help bring more structure to how applications are built, deployed and maintained.</h5>
                        <h5 className='heading-style-h5 mb-5'>This includes setting up deployment pipelines, managing cloud infrastructure, and improving how systems behave under real usage conditions.</h5>
                        <h5 className='heading-style-h5'>The goal is to make systems easier to manage and more predictable in how they behave over time. That means reducing friction in deployments, improving visibility, and keeping infrastructure aligned with application needs.</h5>
                    </Row>
                </Container>
            </section>
            <Container className="padding-section-large">
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We Offer in <span className="text-gradient-1">DevOps and Cloud Solutions</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Capabilities covering deployment, infrastructure management, and system performance.</h5>
                    </Col>
                </Row>
                <Row className="align-items-center mb-5 serviceCard bg-gradient-1 p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>

                        <div className="banner-content">
                            <h4 className='heading-style-h4'>CI/CD Pipeline Setup</h4>
                            <p className="desc">We set up deployment pipelines, so releases are faster, more predictable, and easier to manage.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Continuous integration and deployment setup</span>
                                <span>Automated build and release processes</span>
                                <span>Reduced deployment errors</span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Cloud Infrastructure Management</h4>
                            <p className="desc">We manage cloud environments to support performance, scalability, and system reliability.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>AWS, Azure & Google Cloud infrastructure setup</span>
                                <span>Resource optimization and scaling</span>
                                <span>Environment management</span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Performance Monitoring and Optimisation</h4>
                            <p className="desc">We monitor how systems behave in real usage and step in early when something starts to break or slow down.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Application and infrastructure monitoring</span>
                                <span>Performance tracking and alerts</span>
                                <span>System optimization</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={10}>
                            <h2 className='heading-style-h2 pb-3'>Want to Improve How Your Systems Run?</h2>
                            <p>We can help you shape the right DevOps and cloud approach based on your infrastructure, deployment needs and system complexity.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={2} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Discuss Your Setup</Link>
                        </Col>

                    </Row>
                </Container>
            </section>
            <DevopsApproachCarousel />
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row className=''>
                        <Col md={10}>
                            <h2 className="heading-style-h2 pb-3">What Is the Role of <span className="text-gradient-1">DevOps and Cloud Solutions</span> in Your Business</h2>
                            <h5 className='heading-style-h5 pb-5'>How better infrastructure, deployment and system visibility support day-to-day operations and long-term reliability.</h5>
                        </Col>
                    </Row>
                    <Row className="d-flex align-items-stretch stagger-wrapper">
                        <div className="stagger-grid">
                            {/* Card 1 */}
                            <div className="card-box primary-border light-bg logo-bg">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Faster and more reliable releases</h5>
                                <p>Reduce delays and make deployments easier to manage with clearer release processes.</p>
                            </div>

                            {/* Card 2 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Fewer system disruptions</h5>
                                <p>Keep applications and infrastructure running with fewer disruptions and more predictable performance.</p>
                            </div>

                            {/* Card 3 */}
                            <div className="card-box card-2">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Improved visibility into system health</h5>
                                <p>Track performance, usage and issues more clearly so teams can respond faster.</p>
                            </div>

                            {/* Card 4 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>More efficient infrastructure management</h5>
                                <p>Make cloud environments easier to manage, scale, and maintain over time.</p>
                            </div>

                            {/* Card 5 */}
                            <div className="card-box card-4">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Infrastructure that can handle growth</h5>
                                <p>Prepare systems to handle higher usage, more services, and changing operational demands.</p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
            <TechBlock />
            <ServiceSlider />
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={9}>
                            <h2 className='heading-style-h2 pb-3'>Let’s Make Your Systems Easier to Run</h2>
                            <p>If you need a clearer way to manage infrastructure, deployments, and system reliability, we’re ready to help you move forward.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={3} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Discuss Your Setup</Link>
                        </Col>
                    </Row>
                </Container>
            </section>
            <DevopsCloudFaq />
        </>
    )
}
